module.exports = __webpack_public_path__ + "static/img/timer-start.2d958a5f.svg";